/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnRightDown: {
  name: 'arrow-turn-right-down';
  data: string;
} = {
  name: 'arrow-turn-right-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 6a1 1 0 0 1 1-1h5a2 2 0 0 1 2 2v8.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L12 15.586V7H7a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
